


































import { Component, Vue, Prop } from 'vue-property-decorator';
import BusinessDescription from '@/components/BusinessDescription/BusinessDescription.vue';
import SideModalHeader from '@/components/SideModalHeader/SideModalHeader.vue';
import TableBuilder from '@/components/TableBuilder/TableBuilder.vue';
import TransactionsService from '@/api/ThresholdService';
import DateUtils from '@/utils/DateUtils';

@Component({
  components: {
    BusinessDescription,
    SideModalHeader,
    TableBuilder
  }
})
export default class ThresholdDetails extends Vue {
  @Prop({ required: true }) data!: any;
  total: number | null = null;
  service: TransactionsService = new TransactionsService();

  getMethod = {
    method: 'getCTSTransaction'
  };

  rowsTableProps = {
    hover: true,
    isRounded: true,
    class: 'threshold-details__row'
  };

  tableProps = {
    search: false,
    hasMorePages: true
  };

  headers = [
    {
      label: 'Photo',
      key: 'picture',
      slot: 'picture'
    },
    {
      label: 'Name',
      key: 'customerName'
    },
    {
      label: 'Date',
      key: 'date'
    },
    {
      label: 'Coins amount',
      key: 'amount'
    }
  ];

  addRowsToList = (transactionRows: any[]): any[] =>
    transactionRows.map((transactionRow: any) => ({
      picture: transactionRow.customer.image.small,
      customerName: `${transactionRow.customer.name} ${
        transactionRow.customer.lastname
      }`,
      amount: Math.floor(transactionRow.coins),
      date: DateUtils.formatISODate(transactionRow.createdAt, true)
    }));
}
